import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setAuthenticated } from "@redux/auth/auth";
import { AppDispatch } from "@store/store";
import {
  verifyAuthMe,
  verifyAuthMeRGS,
} from "@services/userModule/UserService";
import { setTokenData } from "@redux/auth/tokenData";
import { useNavigate } from "react-router";
import { ROUTES } from "@routes/RouteConstant";

export const useAuthVerification = (isPortalProtected: boolean) => {
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const verifyUser = async () => {
      try {
        const [verifyAuthData] = await Promise.all([
          verifyAuthMe(),
          verifyAuthMeRGS(),
        ]);

        dispatch(setAuthenticated(true));

        dispatch(
          setTokenData({
            // token: verifyAuthData?.token,
            // tokenexpires: verifyAuthData?.tokenexpires,
            portalProtected: isPortalProtected,
          }),
        );
      } catch {
        navigate(ROUTES.LOGIN, { replace: true });
      } finally {
        setIsLoading(false);
      }
    };

    verifyUser();
  }, []);

  return { isLoading };
};
